// TODO: should probably live next to ViewDataState loading check methods in pivotService cache
export enum ViewDataState {
  idle = 'idle',
  liveDataReady = 'liveDataReady',
  liveDataLoadingNoCache = 'liveDataLoadingNoCache',
  liveDataLoadingFoundCache = 'liveDataLoadingFoundCache',
}
